module.exports = __webpack_public_path__ + "static/media/sandcastle.34b50a58.mov";